function logResults(json){
  //console.log(json);
}

function sortOrder(x, y){
  return x.order - y.order;
}

$(function () {
  $.ajax({
    "url": "https://forms.na2.netsuite.com/app/site/hosting/scriptlet.nl?script=648&deploy=1&compid=1117015&h=350c2597d2e8d3da2466&jsonp=y&jsoncallback='logResults'",
    "type": "get",
    "dataType": "jsonp",
    jsonpCallback: "logResults"
  })
  .done(function (data) {
  	data.sort(sortOrder);
    populateImage(data);
  })
  .fail(function(jqXHR, status, error) {
	console.log(error);
  })
});

function populateImage(data){
    for (var key in data) {
        $('.dashboard-slider').append("<div>"
        	+"<a href='"+data[key].url+"' target='_blank'><img class='small--hide' src='"+data[key].desktop_img+"'></a>"
        	+"<a href='"+data[key].url+"' target='_blank'><img class='medium-up--hide' src='"+data[key].mobile_img+"'></a>"
        	+"</div>");
    }
  	createSlider(data);
}

function createSlider(data){
  	
  	
    $('.dashboard-slider').slick({
    	prevArrow: $('.prev'),
      	nextArrow: $('.next'),
      	appendDots: $('.side-menu-container'),
      	adaptiveHeight: true,
      	
        customPaging: function(slider, i) {
            var title = $(slider.$slides[i]).data('title');
            var date = $(slider.$slides[i]).data('date');
            var key = Object.keys(data)[i];
            return "<div class='slick-data'><p class='time'>"+dateString(data[key].date)+"</p>"
                +"<p class='title'><svg aria-hidden='true' focusable='false' role='presentation' class='icon icon-chevron-right' viewBox='0 0 284.49 498.98'><defs><style>.cls-1{fill:#231f20}</style></defs><path class='cls-1' d='M223.18 628.49a35 35 0 0 1-24.75-59.75L388.17 379 198.43 189.26a35 35 0 0 1 49.5-49.5l214.49 214.49a35 35 0 0 1 0 49.5L247.93 618.24a34.89 34.89 0 0 1-24.75 10.25z' transform='translate(-188.18 -129.51)'></path></svg>"
                +""+data[key].title+"</p>"+
                "</div>";

        },
		dots: true
    });
}

function dateString(date){
	const monthNames = ["", "January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"];
  	var parts = date.split('/');
  	return parts[0]+""+nth(parts[0])+" "+monthNames[parts[1]]+" "+parts[2];

}
function nth(d) {
  if(d>3 && d<21) return 'th'; // thanks kennebec
  switch (d % 10) {
        case 1:  return "st";
        case 2:  return "nd";
        case 3:  return "rd";
        default: return "th";
    }
} 